export enum AgentKnowledgeSource {
  MerchantKnowledge = "MERCHANT_KNOWLEDGE",
  Faq = "FAQ",
}
